<template>
    <div class="main">
		<!-- Super Navbar -->
		<super-nav-inventro v-if="isNavVisible"/>

		<main class="main">
			<!-- Billings Notice -->
			<div class="container" v-if="billingsCount > 0 && billingsNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span
						>Anda memiliki {{ billingsCount }} tagihan yang menunggu untuk
						dibayarkan</span
					>
					<router-link class="ml-auto btn btn-primary" to="/billings">
						Lihat Tagihan
					</router-link>
				</div>
			</div>

			<!-- Limited Stock Notice -->
			<div class="container" v-if="limitedStockProductIds.length > 0 && limitedStockNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span
						>Anda memiliki {{ limitedStockProductIds.length }} produk yang memiliki stock kurang dari atau sama dengan 10</span
					>
					<button class="ml-auto btn btn-primary" @click="goToLimitedStockProducts">
						Lihat Produk
					</button>
				</div>
			</div>

			<!-- Range Stock Checked Notice -->
			<div class="container" v-if="rangeStockCheckedProductsCount.length > 0 && rangeStockCheckedNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3" v-for="(item, idx) in rangeStockCheckedProductsCount" :key="idx">
					<span>Terdapat {{ item.count }} produk yang stocknya kurang dari {{ item.max_range }}</span>
					<button class="ml-auto btn btn-primary" @click="goToRangeStockCheckedProducts(item.max_range)">
						Lihat Produk
					</button>
				</div>
			</div>

			<!-- Stock Checked Notice -->
			<div class="container" v-if="stockCheckedProductsCount > 0 && stockCheckedNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span>Terdapat {{ stockCheckedProductsCount }} produk yang harus diupdate stocknya</span>
					<button class="ml-auto btn btn-primary" @click="goToStockCheckedProducts">
						Lihat Produk
					</button>
				</div>
			</div>

			<!-- Cancelled Submission Notice -->
			<div class="container" v-if="cancelledSubmissionIds.length > 0 && cancelledSubmissionNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span
						>Anda memiliki {{ cancelledSubmissionIds.length }} Order yang dibatalkan</span
					>
					<button class="ml-auto btn btn-primary" @click="goToCancelledSubmission">
						Lihat Order
					</button>
				</div>
			</div>

			<!-- Empty Password Notice -->
			<div class="container" v-if="isPasswordEmpty && emptyPasswordNoticeVisible">
				<div class="alert alert-danger has-shadow flex-center mt-3">
					<span
						>Anda belum mengatur password. Harap masukkan password di halaman profile.</span
					>
					<router-link class="ml-auto btn btn-primary" to="/profile">
						Lihat Profile
					</router-link>
				</div>
			</div>

			<!-- Empty Address Notice -->
			<div class="container" v-if="!isHasStoreAddress && emptyAddressNoticeVisible">
				<div class="alert alert-warning has-shadow flex-center mt-3">
					<span
						>Anda belum mengatur alamat. Harap masukkan alamat di halaman profile.</span
					>
					<router-link class="ml-auto btn btn-primary" to="/profile?tab=address">
						Lihat Profile
					</router-link>
				</div>
			</div>

			<!-- Supplier Empty Address Detail Notice -->
			<div class="container" v-if="!isHasStoreAddressDetail && emptyAddressDetailNoticeVisible">
				<div class="alert alert-warning has-shadow flex-center mt-3">
					<span
						>Anda belum melengkapi alamat toko. Harap lengkapi alamat di halaman settings.</span
					>
					<router-link class="ml-auto btn btn-primary" to="/settings/store">
						Lihat Settings
					</router-link>
				</div>
			</div>

			<!-- Empty Location Notice -->
			<div class="container" v-if="!isHasStoreLocation && emptyLocationNoticeVisible">
				<div class="alert alert-warning has-shadow flex-center mt-3">
					<span>Anda belum mengatur lokasi toko. Harap masukkan lokasi toko di halaman settings.</span>
					<router-link class="ml-auto btn btn-primary" to="/settings/store?to=location">
						Lihat Settings
					</router-link>
				</div>
			</div>

			<router-view v-if="isNotAuthorizedPage || !!user"></router-view>

			<div class="page-loader mt-5" v-else>
				<div class="is-loading dark large"></div>
			</div>
			<announcements
				:visible="isRightbarVisible"
				@close="toggleAnnouncements(false)"
				v-if="isRightbarVisible"
			>
			</announcements>
			<ModalPopupInformation v-if="isModalVisible" :config="currentInformation" @close="closeModal" />
		</main>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
// import dayjs from 'dayjs';
import submissionApi from '@/api/submissions';
import Announcements from '@/components/Announcements.vue';
import homepageApi from '@/api/homepage';
import ModalPopupInformation from '@/components/pop-information/ModalPopup.vue';
import {
	duplicateVar,
} from '@/lib/helper';
import {
	setCookie,
	getCookie,
	// removeCookie
} from '@/lib/cookie';

const SuperNavInventro = () => import(
	/* webpackChunkName: "super-nav-ostock" */ '@/components/inventro/SuperNavInventro.vue'
);

const COOKIE_POPUP_CLOSED_IDS = 'popup_closed_ids';

export default {
	name: 'MainLayout',
	components: {
		Announcements,
		SuperNavInventro,
		ModalPopupInformation,
	},
	data() {
		return {
			informations: [],
			currentInformation: null,
			currentInformationIndex: null,
			isModalVisible: false,
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
			settings: 'settings',
			isLoggedIn: 'isLoggedIn',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			isRoleAdmin: 'isRoleAdmin',
			isHasUsername: 'isHasUsername',
			isHasBankAccounts: 'isHasBankAccounts',
			isRightbarVisible: 'isRightbarVisible',
			notice: 'notice',
			billingsCount: 'billingsCount',
			billingsDueCount: 'billingsDueCount',
			limitedStockProductIds: 'limitedStockProductIds',
			rangeStockCheckedProductsCount: 'rangeStockCheckedProductsCount',
			stockCheckedProductsCount: 'stockCheckedProductsCount',
			cancelledSubmissionIds: 'cancelledSubmissionIds',
			isPasswordEmpty: 'isPasswordEmpty',
			isHasStoreAddress: 'isHasStoreAddress',
			isHasStoreAddressDetail: 'isHasStoreAddressDetail',
			isHasStoreLocation: 'isHasStoreLocation',
			isExpired: 'isExpired',
			isAdmin: 'isAdmin',
			appName: 'appName',
			appProject: 'appProject',
			isUserCan: 'isUserCan',
		}),
		getTimeDifferents() {
			const startDate = new Date();
			const endDate = new Date(startDate);
			endDate.setDate(startDate.getDate() + 1);
			endDate.setHours(0, 0, 0, 0);

			const differenceInMilliseconds = endDate - startDate;
			return differenceInMilliseconds;
		},
		isNotAuthorizedPage() {
			const routePath = this.$route.path;
			const routeName = this.$route.name;
			const isHome = routePath === '/';
			const isLogin = routePath === '/login' || routePath === '/admin/login';
			const isRegister = (routePath === '/register' || routePath === '/register/supplier');
			const isSearch = routePath === '/search';
			const isPages = routePath.includes('/page');
			const isIndex = routePath === '/index.html';
			const isResetPassword = routePath === '/password/reset';
			const isAuthCallback = routePath === '/auth/callback';
			const isBillingRedirect = routePath === '/billings-redirect';
			const isProductDetail = routeName === 'product-detail';
			const isBrand = routePath === '/brand';
			const isDirect = routePath === '/direct';
			const isSupplierProducts = routePath.includes('/supplier');
			const isAllowed = isHome || isIndex || isLogin
							|| isResetPassword || isSearch || isRegister
							|| isAuthCallback || isPages || isBillingRedirect
							|| isProductDetail || isBrand || isDirect
							|| isSupplierProducts;
			return isAllowed;
		},
		isNavVisible() {
			if (this.$route.name === 'phoneVerification') return false;
			return !this.isAdminArea && (this.$route.path.indexOf('/auth/callback') === -1);
		},
		isRoutePageEditor() {
			return this.$route.name !== 'PageEditor';
		},
		billingsNoticeVisible() {
			const blaclistedRoutes = [
				'home',
				'wholesale-order',
				'wholesale-order-detail',
				'wholesale-order-checkout',
				'thank-you',
				'payment-confirmation',
				'payment-success',
				'phoneVerification',
			];
			return this.isRoutePageEditor && !blaclistedRoutes.includes(this.$route.name);
		},
		limitedStockNoticeVisible() {
			return this.isRoutePageEditor && this.isUserCan('product_view') && this.$route.name !== 'phoneVerification';
		},
		rangeStockCheckedNoticeVisible() {
			return this.isRoutePageEditor && this.isUserCan('product_view') && this.$route.name !== 'phoneVerification';
		},
		stockCheckedNoticeVisible() {
			return this.isRoutePageEditor && this.isUserCan('product_view') && this.$route.name !== 'phoneVerification';
		},
		emptyPasswordNoticeVisible() {
			return this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		cancelledSubmissionNoticeVisible() {
			return this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		emptyAddressNoticeVisible() {
			return this.isDropshipper && this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		emptyAddressDetailNoticeVisible() {
			return this.isSupplier && this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		emptyLocationNoticeVisible() {
			return this.isSupplier && this.isRoutePageEditor && this.$route.name !== 'phoneVerification';
		},
		isAdminArea() {
			return this.$route.path.includes('admin');
		},
		// Force OTP - Phone Verification
		emptyPhoneVerification() {
			if (this.$route.path.includes('phone-verification')) {
				return false;
			}
			if (!this.user) {
				return false;
			}
			// return !this.user.is_phone_verified; // TODO : Uncomment to activate
			return false;
		},
		redirectPage() {
			let path = '';
			let pathQuery = '';

			if (this.emptyPhoneVerification) {
				path = '/phone-verification';
				if (this.$route.params.id) {
					path = `/phone-verification/${this.$route.params.id}`;
				}
				pathQuery = '';
			} else if (!this.isHasStoreAddress && this.emptyAddressNoticeVisible) {
				path = '/profile';
				pathQuery = '?tab=address';
			} else if (!this.isHasStoreAddressDetail && this.emptyAddressDetailNoticeVisible) {
				path = '/settings/store';
				pathQuery = '?to=information';
			} else if (!this.isHasStoreLocation && this.emptyLocationNoticeVisible) {
				path = '/settings/store';
				pathQuery = '?to=location';
			}
			return {
				redirectPath: path,
				pathQuery,
				currentPath: this.$route.path,
			};
		},
	},
	created() {
		if (this.isLoggedIn && !this.user) {
			this.fetchUser();
		}

		this.ooDelay(() => {
			if (this.user) {
				this.getDataPopupInformation();
			}
		}, 4000);
	},
	methods: {
		...mapActions({
			toggleAnnouncements: 'toggleAnnouncements',
			setCancelledSubmissionIds: 'setCancelledSubmissionIds',
			fetchUser: 'fetchUser',
		}),
		goToLimitedStockProducts() {
			const productIdsString = this.limitedStockProductIds.join();
			this.$router.push(`/products?product_ids=${productIdsString}`);
		},
		goToRangeStockCheckedProducts(maxRange) {
			this.$router.push(`/products?range_stock=${maxRange}`);
		},
		goToStockCheckedProducts() {
			this.$router.push('/products?stock_checked=1');
		},
		goToCancelledSubmission() {
			const callback = () => {
				this.setCancelledSubmissionIds([]);
			};
			const callbackError = (error) => {
				console.log(error);
				this.$notify({
					group: 'app',
					title: 'Submission',
					text: 'Set Cancel Submission Readed',
					type: 'warn',
				});
			};
			submissionApi.cancelledNoticeReaded(callback, callbackError);
			const productIdsString = this.cancelledSubmissionIds.join();
			this.$router.push(`/orders?submission_ids=${productIdsString}`);
		},
		getDataPopupInformation() {
			// const today = dayjs().format('YYYY-MM-DD');
			const params = {
				// release_date: today,
			};
			const callback = (res) => {
				const informations = res?.data;
				let ownerType = duplicateVar(this.user?.owner_type);
				const roleSupplierTeams = ['owner_admin', 'owner_cs', 'owner_shipper'];
				if (this.user?.owner_type === 'dropshipper') {
					ownerType = 'seller';
				}

				if (roleSupplierTeams.includes(this.user?.role)) {
					ownerType = 'supplier';
				}
				const infoIds = duplicateVar(JSON.parse(getCookie(COOKIE_POPUP_CLOSED_IDS)) ?? []);
				if (infoIds.length === 0 || !infoIds || infoIds === null || infoIds === '') {
					setCookie(COOKIE_POPUP_CLOSED_IDS, JSON.stringify([]), this.getTimeDifferents, null, true);
				}

				this.informations = informations?.filter(info => info?.is_active && !infoIds?.includes(info?._id) && (info?.target === 'seler_supliers' || info?.target === ownerType));

				this.showPopupInformation();
			};
			const err = (e) => {
				console.log(e);
			};

			homepageApi.getDataPopupInformation(params, callback, err);
		},
		showPopupInformation(index = 0) {
			this.currentInformationIndex = index;
			if (this.informations.length > 0) {
				this.currentInformation = this.informations[this.currentInformationIndex];
				this.isModalVisible = true;
			}
		},
		closeModal() {
			const infoCookie = duplicateVar(JSON.parse(getCookie(COOKIE_POPUP_CLOSED_IDS)));
			infoCookie.push(this.currentInformation._id);
			setCookie(COOKIE_POPUP_CLOSED_IDS, JSON.stringify(infoCookie), this.getTimeDifferents, null, true);
			this.currentInformationIndex++;
			const config = this.informations[this.currentInformationIndex];

			this.isModalVisible = false;
			if (config) {
				this.isModalVisible = true;
				this.currentInformation = config;
			}
		},
	},
	watch: {
		user() {
			const slugExist = this.$route.params?.slug ?? null;
			if (this.isAdmin && slugExist !== null) {
				this.$router.push(`/admin/products/preview/${slugExist}`);
			} else if (this.isAdmin && !this.isSupplier && !this.isDropshipper) {
				this.$router.push('/admin');
			}
		},
		redirectPage: {
			handler(newValue) {
				if (!newValue.redirectPath) return;
				if (newValue.currentPath === newValue.redirectPath) return;
				this.$router.push({ path: `${newValue.redirectPath}${newValue.pathQuery}` });
			},
			deep: true,
			immediate: true,
		},
		$route() {
			if (this.isLoggedIn && !this.user) {
				this.fetchUser();
			}

			if (this.user) {
				this.getDataPopupInformation();
			}
		},
	},
};
</script>
